import { Marker } from 'react-map-gl/mapbox';

interface EndingLocationMarkerProps {
  latitude: number;
  longitude: number;
}

const EndingLocationMarker = ({ latitude, longitude }: EndingLocationMarkerProps) => {
  const markerStyle = {
    position: 'relative',
    width: '30px',
    height: '45px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  } as const;

  const pinHeadStyle = {
    width: '30px',
    height: '30px',
    backgroundColor: '#CCCCCC',
    borderRadius: '50%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    border: '2px solid #000000',
    zIndex: 2,
    position: 'relative'
  } as const;

  const pinTailStyle = {
    width: '20px',
    height: '20px',
    backgroundColor: '#CCCCCC',
    clipPath: 'polygon(50% 100%, 0 0, 100% 0)',
    marginTop: '-5px',
    boxShadow: '0 2px 4px rgba(0,0,0,0.3)',
    zIndex: 1
  } as const;

  return (
    <Marker
      latitude={latitude}
      longitude={longitude}
      anchor="bottom"
    >
      <div style={markerStyle}>
        <div style={pinHeadStyle}>
          <span style={{ color: '#000', fontWeight: 'bold', fontSize: 20, fontFamily: 'sans-serif' }}>E</span>
        </div>
        <div style={pinTailStyle} />
      </div>
    </Marker>
  );
};

export default EndingLocationMarker; 